module.exports = __webpack_public_path__ + "img/framboise_namelaka.48ec2ace.jpg";